import { Component, OnInit, Inject } from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from "@angular/material";
import { CoreLogService } from "../../services/log.service";
import { WebVoucherService } from "../../services/web_voucher.service";
import { OverlaySpinnerService } from "../../components/overlayspinner/overlaySpiner.service";
import { WebShopService } from "../../services/webShop.service";
import { CoreLanguageService } from "../../services/language.service";

@Component({
  selector: "ya-webvoucher-dialog",
  templateUrl: "./webvoucherDialog.component.html",
  styleUrls: ["./webvoucherDialog.component.scss"],
  providers: [OverlaySpinnerService]
})
export class WebvoucherDialogComponent implements OnInit {

  public note: string = "";

  constructor(public bottomSheetRef: MatBottomSheetRef<WebvoucherDialogComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public webVoucherNumber: string,
    private _coreLogService: CoreLogService,
    private _coreLanguageService: CoreLanguageService,
    private _webShopService: WebShopService,
    private _overlaySpinnerService: OverlaySpinnerService,
    private _webVoucherService: WebVoucherService) {
  }

  ngOnInit() {
    const me = this;
    me.note = me._coreLanguageService.value("phWebvoucherModal_TextNote");
  }

  /**
   * Remove webvoucher Code from current user
   */
  public RemoveWebvoucher(): void {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    me._webVoucherService.RemoveWebVoucher(me.webVoucherNumber)
      .then((response) => {
        me._webShopService.onUserChange();
        me.bottomSheetRef.dismiss(Promise.resolve(response));
        me._overlaySpinnerService.HideLayoutSpinner();
      })
      .catch(e => {
        me._coreLogService.error("WebvoucherDialogComponent.removeWebvoucher", "webVoucherService.RemoveWebVoucher", e);
        me.bottomSheetRef.dismiss(Promise.reject());
        me._overlaySpinnerService.HideLayoutSpinner();
      });
  }

}
